import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum AirbnbOfficialLinkStatus {
  inactive = 'inactive',
  confirmed = 'confirmed',
  readOnly = 'read_only',
  onboarding = 'onboarding',
}

export default class AirbnbOfficialLinkModel extends Model {
  @attr('string') status?: AirbnbOfficialLinkStatus;
  @attr('string') matchedListingId?: string;

  @belongsTo('property', { inverse: 'airbnbOfficialLink', async: false })
  property!: ModelRegistry['property'];

  @belongsTo('airbnb-official-connection', {
    inverse: 'airbnbOfficialLinks',
    async: true,
  })
  airbnbOfficialConnection!: ModelRegistry['airbnb-official-connection'];

  @belongsTo('airbnb-official-listing', { inverse: null, async: false })
  airbnbOfficialListing?: ModelRegistry['airbnb-official-listing'];

  @cached
  get isReadOnly(): boolean {
    return this.status === AirbnbOfficialLinkStatus.readOnly;
  }

  @cached
  get isInactive(): boolean {
    return this.status === AirbnbOfficialLinkStatus.inactive;
  }

  @cached
  get isConfirmed(): boolean {
    return this.status === AirbnbOfficialLinkStatus.confirmed;
  }
  @cached
  get isOnboarding(): boolean {
    return this.status === AirbnbOfficialLinkStatus.onboarding;
  }

  @cached
  get nickname(): string {
    return this.property.nickname;
  }

  get channelConnectionId(): string | undefined {
    const id = (this as AirbnbOfficialLinkModel)
      .belongsTo('airbnbOfficialConnection')
      .id();

    return id ? `airbnb_${id}` : undefined;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-link': AirbnbOfficialLinkModel;
  }
}
